import { combineReducers } from 'redux';
import guestSummary from './guest-summary';
import donorSummary from './donor-summary';
import lowStockItems from './low-stock-items';
import itemsAndPackagesSkus from './items-and-packages-skus';

export default combineReducers({
  guestSummary,
  donorSummary,
  lowStockItems,
  itemsAndPackagesSkus
});
